export default {
    BASE_URL: '/bid/support',
    api: [
      {
        name: 'list',
        method: 'GET',
        desc: '获取服务支持列表',
        path: '/list'
      },
      {
        name: 'handle',
        method: 'POST',
        desc: '处理',
        path: '/handled'
      },
      {
        name: 'unitInfo',
        method: 'GET',
        desc: '获取单位信息',
        path: '/orgInfo'
      },
      {
        name: 'handleList',
        method: 'GET',
        desc: '处理情况下拉',
        path: '/handleStatus'
      }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/apis/tender/support.js